module.exports = __webpack_public_path__ + "img/bg.fcf6b07c.png";